import { Observable } from 'rxjs';
import { Request, GetRequests } from './requests.model';

export abstract class RequestsService {
    abstract getRequests(page: number, limit: number): Observable<GetRequests>;
    abstract getRequestDetail(id: string): Observable<Request>;
    abstract modifyRequest(id: string, payload: any): Observable<Request>;
}
